const braintree = require('braintree-web');
const $ = require('jquery');

class PaypalService {
    constructor(restangular, $q) {
        this._q = $q;
        this._api = restangular.one('Paypal');
        this.integration = null;
        this.callBack = null;
        this._cachedCustomer = null;
    }

    setup(paypal, callBack) {
        const self = this;
        const deferred = this._q.defer();
        this.token = null;
        this.nonce = null;
        this.customerEmail = null;
        this.integration = null;
        this._cachedCustomer = null;

        const options = $.extend({
            displayName: 'BWS',
            enableShippingAddress: false,
            enableBillingAddress: false,
            shippingAddressOverride: {
                 editable: false
            },
            headless: true
        }, paypal);

        this._api.post('Token')
            .then(function (response) {
                braintree.setup(response.ClientToken, 'custom', {
                    onReady(integration) {
                        self.integration = integration;
                        deferred.resolve({ hasError: false });
                    },
                    onError(type, message) {
                        deferred.reject({ hasError: true, type, message });
                    },
                    onPaymentMethodReceived(payload) {
                        // retrieve nonce from payload.nonce
                        if (callBack != null) {
                            callBack(payload);
                        }
                    },
                    paypal: options
                });
            });

        return deferred.promise;
    }

    initAuthFlow(paypal) {
        if (!this.isReady()) {
            this.setup(paypal, () => { this.integration.paypal.initAuthFlow(); });
            return;
        }
        this.integration.paypal.initAuthFlow();
    }

    getCurrentCustomer() {
        if (!this._cachedCustomer) {
          this._cachedCustomer = this._api.post('Customer');
        }
        return this._cachedCustomer;
    }

    removeAccount() {
        const self = this;
        return this._api.post('Remove').then(function () {
            self.token = null;
            self.nonce = null;
        });
    }

    isReady() {
        return this.integration !== null && this.integration !== undefined;
    }

    isTokenized() {
        return this.token !== null && this.token !== undefined;
    }

    linkAccount(nonce, email) {
        return this._api.post('Link', { Nonce: nonce, Email: email });
    }

    resolveAddress(details) {
        if (details.shippingAddress !== undefined && details.shippingAddress !== null) {
            return details.shippingAddress;
        }

        if (details.billingAddress !== undefined && details.billingAddress !== null) {
            return details.billingAddress;
        }

        return null;
    }
}

module.exports = PaypalService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/paypal/paypal-service.js
 **/